module.exports = __webpack_public_path__ + "img/1724249069758-IMG_1530.png.af66afa9.webp";